<template>
    <footer class="section footer-area">
        <!-- Footer Top -->
        <div class="footer-top ptb_100">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-uppercase mb-2">{{$t('footer.services')}}</h3>
                            <ul>
                                <li class="py-2"><a class="text-black-50" href="/product">{{$t('footer.website')}}</a></li>
                                <li class="py-2"><a class="text-black-50" href="/product">{{$t('footer.app')}}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-uppercase mb-2">{{$t('footer.ourwork')}}</h3>
                             <!-- <div style="height:10px"></div> -->
                            <ul>
                                <li class="py-2"><a class="text-black-50" href="/product">{{$t('footer.workwebsite')}}</a></li>
                                <li class="py-2"><a class="text-black-50" href="/product">{{$t('footer.workapp')}}</a></li>
                                <!-- <img src="assets/img/wing_icon.png" alt="wing icon" width="60" height="160"><br>
                                <div style="height:20px"></div>
                                <img src="assets/img/e-money.png" alt="e-money icon" width="50" height="100"><br>
                                <img src="assets/img/ACELDA.png" alt="ACELDA icon" width="80" height="160"><br> -->
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <!-- <h3 class="footer-title text-uppercase mb-2">{{$t('footer.call_center')}}</h3>
                            <ul>
                                <li class="py-2"><a class="text-black-50">{{$t('footer.service_from')}}<br>{{$t('footer.day_work1')}}<br>{{$t('footer.day_work2')}}</a></li>
                                <li class="py-2"><a class="text-black-50" href="tel:+499123456789" ><i class="fas fa-phone-alt"></i> +855 (0)10 22 50 44</a></li>
                            </ul><br> -->
                            <h3 class="footer-title text-uppercase mb-2">{{$t('footer.contactus')}}</h3>
                            <ul>
                                <li class="py-2"><a class="text-black-50"><i class="fas fa-home"></i>  {{$t('footer.addr_branch_1')}}</a></li>
                                <li class="py-2"><a class="text-black-50" href="tel:+66621966196" ><i class="fas fa-phone-alt"></i> +66 (0)621966196</a></li>
                                <li class="py-2"><a class="text-black-50" href="mailto:spdevsolution@gmail.com"><i class="fas fa-envelope"></i>   {{$t('footer.email')}} : spdevsolution@gmail.com</a></li>

                            </ul><br>

                            <!-- <ul>
                                <li class="py-2"><a class="text-black-50"><i class="fas fa-home"></i>   {{$t('footer.branch_2')}}<br>{{$t('footer.addr_branch_5')}}<br>{{$t('footer.addr_branch_6')}}<br>{{$t('footer.addr_branch_7')}}</a></li>
                                <li class="py-2"><a class="text-black-50" href="tel:+85570255044" ><i class="fas fa-phone-alt"></i> +855 (0)70 25 50 44</a></li><br>
                            </ul>

                              <ul>
                                <li class="py-2"><a class="text-black-50" href="mailto:rptnrafco@gmail.com"><i class="fas fa-envelope"></i>   {{$t('footer.email')}} : rptnrafco@gmail.com</a></li><br>
                            </ul>

                              <ul>
                                <li class="py-2"><a class="text-black-50" href="https://rafcocambodia.com/" ><i class="fas fa-globe"></i>   {{$t('footer.website')}} : https://rafcocambodia.com/</a></li><br>
                            </ul> -->

                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <!-- Footer Items -->
                        <div class="footer-items">
                            <!-- Footer Title -->
                            <h3 class="footer-title text-uppercase mb-2">{{$t('footer.follow_us')}}</h3>
                            <p class="mb-2">{{$t('footer.follow')}}</p>
                            <!-- Social Icons -->
                            <ul class="social-icons list-inline pt-2">
                                <li class="list-inline-item px-1"><a href="https://www.facebook.com/spdevsolution/" target="_blank"><i class="fab fa-facebook"></i></a></li>
                                <li class="list-inline-item px-1"><a href="https://www.instagram.com/rafcocambodia/" target="_blank"><i class="fab fa-line"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Footer Bottom -->
        <div class="footer-bottom bg-grey">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!-- Copyright Area -->
                        <div class="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                            <!-- Copyright Left -->
                            <div class="copyright-left">&copy; Copyrights 2021 - 2022  SPdev Solution ALL RIGHTS RESERVED</div>
                            <!-- Copyright Right -->
                            <!-- <div class="copyright-right">Made with <i class="fas fa-heart"></i> By <a href="#">Themeland</a></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>